import { createSlice } from "@reduxjs/toolkit";
import {
  createExtraReducersForThunk,
  createApiThunkPrivate,
} from "../_helpers/ApiThunk";

const initialState = {
  getAdminPostListData: {},
  getAdminPostDetailData: {},
  enablePostByAdminData: {},
  getAdminForumListData: {},
  getAdminForumDetailData: {},
  enableForumByAdminData: {},
  getAdminCommunityGroupListData: {},
  getAdminCommunityGroupDetailData: {},
  getAdminCommunityGroupChatsData: {},
  enableCommunityPostByAdminData: {},
  enableCommunityGroupByAdminData: {},
};

export const getAdminPostList = createApiThunkPrivate(
  "getAdminPostList",
  "/admin-social-management/posts/getList",
  "GET",
);
export const getAdminPostDetail = createApiThunkPrivate(
  "getAdminPostDetail",
  "/admin-social-management/posts/getDetail",
  "GET",
);
export const enablePostByAdmin = createApiThunkPrivate(
  "enablePostByAdmin",
  "/admin-social-management/posts/enableDisableByAdmin",
  "PUT",
);
export const getAdminForumList = createApiThunkPrivate(
  "getAdminForumList",
  "/admin-social-management/forums/getList",
  "GET",
);
export const getAdminForumDetail = createApiThunkPrivate(
  "getAdminForumDetail",
  "/admin-social-management/forums/getDetail",
  "GET",
);
export const enableForumByAdmin = createApiThunkPrivate(
  "enableForumByAdmin",
  "/admin-social-management/forums/enableDisableByAdmin",
  "PUT",
);
export const getAdminCommunityGroupList = createApiThunkPrivate(
  "getAdminCommunityGroupList",
  "/admin-social-management/community-groups/getList",
  "GET",
);
export const getAdminCommunityGroupDetail = createApiThunkPrivate(
  "getAdminCommunityGroupDetail",
  "/admin-social-management/community-groups/getDetail",
  "GET",
);
export const getAdminCommunityGroupChats = createApiThunkPrivate(
  "getAdminCommunityGroupChats",
  "/admin-social-management/community-groups/getChats",
  "GET",
);
export const enableCommunityPostByAdmin = createApiThunkPrivate(
  "enableCommunityPostByAdmin",
  "/admin-social-management/community-posts/enableDisableByAdmin",
  "PUT",
);
export const enableCommunityGroupByAdmin = createApiThunkPrivate(
  "enableCommunityGroupByAdmin",
  "/admin-social-management/community-groups/enableDisableByAdmin",
  "PUT",
);

const socialManagementSlice = createSlice({
  name: "socialManagement",
  initialState,
  extraReducers: (builder) => {
    createExtraReducersForThunk(builder, getAdminPostList, "getAdminPostListData");
    createExtraReducersForThunk(builder, getAdminPostDetail, "getAdminPostDetailData");
    createExtraReducersForThunk(builder, enablePostByAdmin, "enablePostByAdminData");
    createExtraReducersForThunk(builder, getAdminForumList, "getAdminForumListData");
    createExtraReducersForThunk(builder, getAdminForumDetail, "getAdminForumDetailData");
    createExtraReducersForThunk(builder, enableForumByAdmin, "enableForumByAdminData");
    createExtraReducersForThunk(
      builder,
      getAdminCommunityGroupList,
      "getAdminCommunityGroupListData",
    );
    createExtraReducersForThunk(
      builder,
      getAdminCommunityGroupDetail,
      "getAdminCommunityGroupDetailData",
    );
    createExtraReducersForThunk(
      builder,
      getAdminCommunityGroupChats,
      "getAdminCommunityGroupChatsData",
    );
    createExtraReducersForThunk(
      builder,
      enableCommunityPostByAdmin,
      "enableCommunityPostByAdminData",
    );
    createExtraReducersForThunk(
      builder,
      enableCommunityGroupByAdmin,
      "enableCommunityGroupByAdminData",
    );
  },
});

export default socialManagementSlice.reducer;
